import { env } from 'process'
import { datadogRum } from '@datadog/browser-rum'
import TagManager from 'react-gtm-module'
import { ILoginUser as User } from 'src/services/types/user'
import { hasFeature } from '../utils/hasFeature'

const ASSET_HOST = process.env.NEXT_PUBLIC_ASSET_HOST

export function prependAssetHost(url: string, path?: string) {
    if (url != null && url.startsWith('http')) return url
    if (path) {
        return ASSET_HOST + path + url
    }

    return ASSET_HOST + url
}

export function prependAssetHostChallenge(url) {
    if (
        typeof url !== 'undefined' &&
        url !== null &&
        !url.startsWith('http') &&
        url.length > 27
    )
        //Skip the initial '/s3/asset.makeyeshappen.com' on the path
        url = url.substring(27)
    return prependAssetHost(url, '')
}

export function prependAssetHostItem(url) {
    return prependAssetHost(url, '/challenges/')
}

export const shimmer = (w: number, h: number) => `
<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="#333" offset="20%" />
      <stop stop-color="#222" offset="50%" />
      <stop stop-color="#333" offset="70%" />
    </linearGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="#333" />
  <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
</svg>`

export const toBase64 = (str: string) =>
    typeof window === 'undefined' ? Buffer.from(str).toString('base64') : window.btoa(str)

export function registerIdentifiedUser(profile: User) {
    const tagManagerArgs = {
        dataLayer: {
            userId: profile.userId,
            email: profile.email,
            fbemail: profile.emailForPixel,
            name: `${profile.firstName} ${profile.lastName}`,
            city: profile.cityForPixel,
            state: profile.stateForPixel,
            zip: profile.zipForPixel,
            gender: profile.genderForPixel,
            dob: profile.dobForPixel
        }
    }
    TagManager.dataLayer(tagManagerArgs)

    const hasDataDogFeature = hasFeature('datadog', { profile })

    if (hasDataDogFeature) {
        datadogRum.init({
            applicationId: env.NEXT_PUBLIC_DD_APPLICATION_ID,
            clientToken: env.NEXT_PUBLIC_DD_CLIENT_TOKEN,
            site: env.NEXT_PUBLIC_DD_SITE,
            service: env.NEXT_PUBLIC_DD_SERVICE,
            env: env.NEXT_PUBLIC_APP_ENV,
            version: env.NEXT_PUBLIC_VERSION,
            sampleRate: 100,
            trackInteractions: true,
            trackSessionAcrossSubdomains: true
        })
    }
}
